import React, { Component } from 'react';
import { Modal, message, DatePicker } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { MonthPicker } = DatePicker;

class ExportDataModal extends Component {
    state = {
        visible: false,
        loading: false,
        yearMonth: '',
    }

    show = () => {
        const curMonth = moment().format('YYYY-MM');
        this.setState({ visible: true, yearMonth: curMonth });
    }

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            yearMonth: '',
        });
    }

    confirm = () => {
        const { yearMonth } = this.state;
        const url = API_URL.manhour.manHourRecordExport;

        if (!yearMonth) {
            message.warning('请选择固化月份');
            return;
        }

        this.setState({ loading: true });
        // 先用 AJAX 请求预检是否有数据或报错
        // 若接口返回 JSON 且含 error，则捕获并提示；若返回文件流，则 JSON 解析失败，视为校验通过。
        $.sendRequest({
            method: 'POST',
            url,
            data: { date: yearMonth },
            dataType: 'json',
            showError: false, // 禁用 AjaxRequest 的默认 message.error 提示
            hideFailMessage: true, // 禁用 AjaxRequest 的默认 "获取服务失败" 提示
            doneResult: (res) => {
                this.setState({ loading: false });
                if (res.error) {
                    message.warning(res.error);
                } else {
                    // 理论上如果是导出接口，成功时不会进入这里（因为返回的是文件流，解析 JSON 会报错）
                    // 但如果后端返回了成功的 JSON，我们也执行导出
                    ExportUtil.export({ date: yearMonth }, null, url, true);
                    this.hide();
                }
            },
            errorResult: (err) => {
                this.setState({ loading: false });
                message.warning(err);
            },
            failResult: () => {
                // 解析 JSON 失败，说明返回的可能不是 JSON（即可能是文件流）
                // 这种情况下说明校验通过，可以执行真正的导出
                this.setState({ loading: false });
                ExportUtil.export({ date: yearMonth }, null, url, true);
                this.hide();
            }
        });
    }

    handleMonthChange = (date, dateString) => {
        this.setState({ yearMonth: dateString })
    }

    disabledDate = (current) => {
		// 只能选择2026年4月及之后的月份
		return current && current < moment('2026-04', 'YYYY-MM');
	}
    render() {
        const { visible, loading, yearMonth } = this.state;
        return (
            <Modal
                title="导出固化数据"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={loading}
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <label>请选择固化月份</label>
                    <MonthPicker
                        allowClear={false}
                        style={{ margin: '0px 0px 10px 10px', width: 180 }}
                        disabledDate={this.disabledDate}
                        value={yearMonth ? moment(yearMonth) : null}
                        placeholder="请选择月份"
                        onChange={this.handleMonthChange}
                    />
                </div>
            </Modal>
        )
    }
}

export default ExportDataModal;


// WEBPACK FOOTER //
// ./src/components/manHour/query/ExportDataModal.js